<template>
  <vx-card>
    <div class="vx-card__title mb-10">
      <h4 class="mb-4">Подключение мессенджеров</h4>
      <p>Выберите нужные каналы общения.</p>
    </div>
    <div class="services-list">
      <div class="services-list__item">
        <whats-app-service
          :channel-slug="channelSlug"
        />
      </div>
      <div class="services-list__item">
        <waba-service
          :channel-slug="channelSlug"
        />
      </div>
      <div class="services-list__item">
        <bachata-service
          :channel-slug="channelSlug"
        />
      </div>
    </div>
  </vx-card>
</template>

<script>
import WabaService from './WabaService'
import WhatsAppService from './WhatsAppService'
import BachataService from './BachataService'

export default {
  props: {
    channelSlug: {
      type: String,
      required: true
    }
  },

  components: {
    WabaService,
    WhatsAppService,
    BachataService
  }
}
</script>
